/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAIConfigTargetingPathParams = NonNullable<operations['patchAIConfigTargeting']['parameters']['path']>;

export type PatchAIConfigTargetingQueryParams = NonNullable<
  operations['patchAIConfigTargeting']['parameters']['query']
>;

export type PatchAIConfigTargetingRequestBody = OperationRequestBodyContent<operations['patchAIConfigTargeting']>;

export interface Input extends PatchAIConfigTargetingPathParams {
  apiVersion?: string;
  query?: PatchAIConfigTargetingQueryParams;
  body: PatchAIConfigTargetingRequestBody;
}

export async function patchAIConfigTargeting(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/ai-configs/{configKey}/targeting', {
    params: { path, query },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
